import React from 'react';
import PropTypes from 'prop-types';
import AvailabilityTypeItem from '../AvailabilityTypeItem';

const propTypes = {
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    availClass: PropTypes.string.isRequired,
    altTitle: PropTypes.string.isRequired
};

export default class BaseAvailabilityType extends React.Component {
    render() {
        return (
            <AvailabilityTypeItem
                name={this.props.name}
                text={this.props.text}
                availClass={this.props.availClass}
                altTitle={this.props.altTitle}
                key={this.props.name} />
        );
    }
}

BaseAvailabilityType.propTypes = propTypes;
